import { useCallback } from 'react';
import { useMediaLibraryStore } from '../store/mediaLibraryStore';

/**
 * Upload files to the workspace media library (R2-backed).
 * Does NOT add to project or create timeline clips — that happens on drag-drop.
 */
export function useIngest() {
  const assets = useMediaLibraryStore((s) => s.assets);
  const uploadFile = useMediaLibraryStore((s) => s.uploadFile);

  const ingest = useCallback(async (files: File[]) => {
    for (const file of files) {
      await uploadFile(file);
    }
  }, [uploadFile]);

  return { ingest, assets };
}
